import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { ProposalsState } from "../../models/proposals-state";

const initialState: ProposalsState = {
	loading: true,
	allRetrieved: false
};

const reducer = createReducer(
	initialState,
	on(OrderProposalActions.financials.getSuccess, (state, action) => _.omit(action, "type")),
	on(OrderProposalActions.financials.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function proposalFinancialReducer(
	state: ProposalsState | undefined,
	action: Action
): ProposalsState {
	return reducer(state, action);
}
